(() => {
  const init = (root) => {
    if (root.dataset.daHeroReady) return;
    root.dataset.daHeroReady = '1';

    const slides = [...root.querySelectorAll('[data-da-slide]')];
    const dots = [...root.querySelectorAll('[data-da-dot]')];
    if (slides.length < 2) return;

    let index = 0;
    let timer = null;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const delay = Number(root.dataset.autoplay) || 6000;

    const toggle = root.querySelector('[data-da-toggle]');
    const iconPause = root.querySelector('[data-da-icon-pause]');
    const iconPlay = root.querySelector('[data-da-icon-play]');
    let paused = reduced;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };

    const start = () => {
      if (reduced || paused || timer) return;
      timer = setInterval(() => show(index + 1), delay);
    };

    const stop = () => {
      clearInterval(timer);
      timer = null;
    };

    const paint = () => {
      if (!toggle) return;
      toggle.setAttribute('aria-label', paused ? 'Retomar troca automática de imagens' : 'Pausar troca automática de imagens');
      iconPause?.toggleAttribute('hidden', paused);
      iconPlay?.toggleAttribute('hidden', !paused);
    };

    const jump = (next) => {
      stop();
      show(next);
      start();
    };

    // WCAG 2.2.2: o visitante precisa conseguir parar o movimento e ele deve ficar parado.
    toggle?.addEventListener('click', () => {
      paused = !paused;
      paused ? stop() : start();
      paint();
    });

    root.querySelector('[data-da-prev]')?.addEventListener('click', () => jump(index - 1));
    root.querySelector('[data-da-next]')?.addEventListener('click', () => jump(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => jump(i)));

    const onVisibility = () => (document.hidden ? stop() : start());
    document.addEventListener('visibilitychange', onVisibility);

    // O editor de tema destroi e recria a secao: sem isto, cada re-render
    // deixaria um setInterval e um listener orfaos rodando.
    root.addEventListener('da-hero:destroy', () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
    }, { once: true });

    paint();
    start();
  };

  const scan = () => document.querySelectorAll('[data-da-hero]').forEach(init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();

  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-da-hero]').forEach((el) => el.dispatchEvent(new Event('da-hero:destroy')));
  });
})();
